<template>
	<div>
		<el-row style="background-color: lightgray;margin-bottom: 20px;padding-left: 30px;">全部{{totalResultCount}}条收藏文章</el-row>
		<el-row v-for="(item,index) in resultDataList" style="padding: 10px;">
			<el-row>
				<el-col :span="20">
					<el-row>
						<router-link :to="{ name: 'detail', params: { id: item.articleid }}" style="font-weight: bold;">
							{{item.title}}</router-link>
					</el-row>
					<el-row>
						{{item.updatetime.substring(0,10)}}
					</el-row>
				</el-col>
				<el-col :span="4">
					<el-popconfirm @confirm="removefavo(item.id)" title="确定要删除此条收藏吗？">
					  <i slot="reference" class="el-icon-star-on" style="font-size: 28px;"></i>
					</el-popconfirm>
				</el-col>
			</el-row>
			<el-row>
				<el-divider></el-divider>
			</el-row>
		</el-row>
		<el-row class="pagediv">
			<el-pagination @size-change="changePageSize" @current-change="changeSearchPage" :current-page="pageNum"
				:page-sizes="[10, 30, 50]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
				:total="totalResultCount">
			</el-pagination>
		</el-row>
		<div class="m_b1"></div>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				loadingMask: false,
				pageNum: 1,
				pageSize: 10,
				totalResultCount: 0,
				resultDataList: [],
			}
		},
		props: [
			'userinfo'
		],
		mounted: function() {
			this.getFavoritefnc();
		},
		methods: {
			getFavoritefnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/lstFavorites',
						responseType: 'json',
						params: {
							userid: this.userinfo.userAccountID,
							type:1,
							iPageNum: this.pageNum,
							iPageSize: this.pageSize,
						},
					})
					.then(function(response) {
						_this.resultDataList = response.data.data.data.tempResult.artLst;
						_this.totalResultCount = response.data.data.data.tempResult.totalCount;
						_this.loadingMask = false;
						_this.$emit('senddata',_this.totalResultCount);
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			removefavo: function(id) {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/DelFavorites',
						responseType: 'json',
						params: {
							id: id,
						},
					})
					.then(function(response) {
						if(response.data.data.data.code=='0'){
							_this.$track([
								['pagetype','删除收藏'],
								['pageid',_this.articleid]
							]);
							_this.changeSearchPage(1);
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changePageSize: function(pagesize) {
				this.pageSize = pagesize;
				this.getFavoritefnc();
			},
			changeSearchPage: function(page) {
				// console.log(page);
				this.pageNum = page;
				this.getFavoritefnc();
			},
		},
	}
</script>

<style>
</style>
